import { compose } from 'redux';
import { connect } from 'react-redux';
import {
    GetOuterServerMailRequested,
    ClearGetOuterServerMail,
    UpdateOuterServerMailRequested,
    ClearUpdateOuterServerMail,
    DeleteOuterServerMailRequested,
    ClearDeleteOuterServerMail,
} from '../../../actions/OuterServerMail';
import OuterServerMail from '../../../pages/Admin/OuterServerMail/OuterServerMail';
import withAuth from '../../../common/WithAuth';

const mapStateToProps = (state) => ({
    mailSetting: state.outerServerMail.getMail.data,
    isLoading: state.outerServerMail.getMail.isFetching
        || state.outerServerMail.updateMail.isFetching
        || state.outerServerMail.deleteMail.isFetching,
    updateSuccess: state.outerServerMail.updateMail.success || state.outerServerMail.deleteMail.success,
    updateFail: state.outerServerMail.updateMail.errors || state.outerServerMail.deleteMail.errors,
});

const mapDispatchToProps = (dispatch) => ({
    getOuterServerMail: (shortName) => dispatch(GetOuterServerMailRequested(shortName)),
    clearGetOuterServerMail: () => dispatch(ClearGetOuterServerMail()),
    updateOuterServerMail: (shortName, params) => dispatch(UpdateOuterServerMailRequested({ shortName, params })),
    clearUpdateOuterServerMail: () => dispatch(ClearUpdateOuterServerMail()),
    deleteOuterServerMail: (shortName) => dispatch(DeleteOuterServerMailRequested(shortName)),
    clearDeleteOuterServerMail: () => dispatch(ClearDeleteOuterServerMail()),
});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(OuterServerMail);
